import type { CustomCellRendererProps } from '@mint-lib/ag-grid/react';

import { LoadingCell } from '@mint-lib/ag-grid/components';
import { useDateFormatter } from '@mint-lib/formatting-hooks';
import type { DateRange } from '@mint-lib/tw-components/patterns';

import { LOADING_STATE } from '../../../../consts/flights.js';
import { FLIGHT_TOTAL_ROW_ID } from '../../../../types/flights.types.js';

type CellData = {
  id: string;
  dateFrom: string;
  dateTo: string;
};

const FlightDateRangeRenderer = (
  params: CustomCellRendererProps<CellData, DateRange>,
) => {
  const isCellLoading = params.data?.id === LOADING_STATE;
  const isTotalsLoading =
    params.data?.id === FLIGHT_TOTAL_ROW_ID &&
    params.data?.dateFrom === LOADING_STATE;

  const isLoading = !params.data || isCellLoading || isTotalsLoading;

  const { formattedDateRange } = useDateFormatter(
    isLoading ? undefined : params.value?.from,
    isLoading ? undefined : params.value?.to,
  );

  if (isLoading) {
    return <LoadingCell />;
  }

  return <span>{formattedDateRange}</span>;
};

export default FlightDateRangeRenderer;
